/* FI Galaxy — animated cosmic background.
   Any element with [data-fg-constellation] gets a canvas behind its content:
   drifting nebula haze, a field of faint distant stars, a linked constellation
   layer, and a rare shooting star. data-fg-constellation="light" = dark ink. */
(function () {
	'use strict';
	if (window.__fgConstellation) return;
	window.__fgConstellation = true;

	var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function init(host) {
		if (host.__fgC) return;
		host.__fgC = true;
		if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

		var canvas = document.createElement('canvas');
		canvas.setAttribute('aria-hidden', 'true');
		canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:0';
		host.insertBefore(canvas, host.firstChild);
		var ctx = canvas.getContext('2d');

		var light = host.getAttribute('data-fg-constellation') === 'light';
		var C = light
			? { line: '110,70,200', cursor: '120,80,210', glow: '140,100,230', dot: '70,45,140', dotA: 0.55, lineA: 0.28, far: '90,70,150', neb: ['150,110,230', '110,140,230', '200,120,210'], nebA: 0.07 }
			: { line: '176,140,255', cursor: '220,200,255', glow: '210,190,255', dot: '240,234,255', dotA: 0.85, lineA: 0.3, far: '225,220,255', neb: ['120,70,230', '60,90,210', '190,70,200'], nebA: 0.07 };

		var W = 0, H = 0, dpr = 1, pts = [], far = [], neb = [], shoots = [], nextShoot = 0;
		var mouse = { x: -9999, y: -9999 }, running = true, visible = true, raf = 0;
		var attract = null; // { y, left, right } in host coords while a portal button is hovered
		var BTN = '.fg-hero-aside a, .fg-pcard__row, .fg-pcard__login';
		function setAttract(btn) {
			if (!btn) { attract = null; return; }
			var hr = host.getBoundingClientRect(), br = btn.getBoundingClientRect();
			var card = btn.closest('.fg-hero-aside, .fg-pcard') || btn;
			var cr = card.getBoundingClientRect();
			attract = { y: br.top + br.height / 2 - hr.top, left: cr.left - hr.left - 26, right: cr.right - hr.left + 26 };
		}
		host.addEventListener('pointerover', function (e) { var b = e.target.closest && e.target.closest(BTN); if (b && host.contains(b)) setAttract(b); });
		host.addEventListener('pointerout', function (e) {
			var b = e.target.closest && e.target.closest(BTN);
			if (b && !(e.relatedTarget && b.contains(e.relatedTarget))) attract = null;
		});
		host.addEventListener('focusin', function (e) { var b = e.target.closest && e.target.closest(BTN); if (b) setAttract(b); });
		host.addEventListener('focusout', function () { attract = null; });
		var LINK = 140;

		function seed() {
			var area = W * H;
			var n = Math.min(210, Math.max(60, Math.round(area / 6000)));
			pts = [];
			for (var i = 0; i < n; i++) {
				pts.push({
					x: Math.random() * W, y: Math.random() * H,
					hx: 0, hy: 0, vx: 0, vy: 0, bvx: (Math.random() - 0.5) * 0.24, bvy: (Math.random() - 0.5) * 0.24,
					r: Math.random() * 1.3 + 0.5,
					tw: Math.random() * Math.PI * 2,
					bright: Math.random() < 0.1
				});
			}
			var m = Math.min(700, Math.round(area / 2200));
			far = [];
			for (var k = 0; k < m; k++) {
				far.push({
					x: Math.random() * W, y: Math.random() * H,
					r: Math.random() * 0.7 + 0.25,
					a: Math.random() * 0.35 + 0.1,
					tw: Math.random() * Math.PI * 2,
					sp: Math.random() * 0.0012 + 0.0004
				});
			}
			neb = [];
			for (var j = 0; j < 3; j++) {
				neb.push({
					x: Math.random() * W, y: Math.random() * H,
					R: Math.max(W, H) * (0.35 + Math.random() * 0.25),
					ax: Math.random() * Math.PI * 2, ay: Math.random() * Math.PI * 2,
					c: C.neb[j % C.neb.length]
				});
			}
		}

		function homeAll() { for (var i = 0; i < pts.length; i++) { pts[i].hx = pts[i].x; pts[i].hy = pts[i].y; } }

		function resize() {
			var r = host.getBoundingClientRect();
			dpr = Math.min(window.devicePixelRatio || 1, 2);
			W = Math.max(1, r.width); H = Math.max(1, r.height);
			canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
			ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
			seed();
			homeAll();
			if (reduce) frame(0);
		}

		function drawNebula(t) {
			for (var i = 0; i < neb.length; i++) {
				var n = neb[i];
				var x = n.x + (reduce ? 0 : Math.sin(t * 0.00005 + n.ax) * W * 0.06);
				var y = n.y + (reduce ? 0 : Math.cos(t * 0.00004 + n.ay) * H * 0.06);
				var g = ctx.createRadialGradient(x, y, 0, x, y, n.R);
				g.addColorStop(0, 'rgba(' + n.c + ',' + C.nebA + ')');
				g.addColorStop(0.5, 'rgba(' + n.c + ',' + (C.nebA * 0.35).toFixed(3) + ')');
				g.addColorStop(1, 'rgba(' + n.c + ',0)');
				ctx.fillStyle = g;
				ctx.fillRect(0, 0, W, H);
			}
		}

		function drawFar(t) {
			for (var i = 0; i < far.length; i++) {
				var s = far[i];
				var a = reduce ? s.a : s.a * (0.55 + 0.45 * Math.sin(t * s.sp + s.tw));
				ctx.fillStyle = 'rgba(' + C.far + ',' + a.toFixed(3) + ')';
				ctx.fillRect(s.x, s.y, s.r * 2, s.r * 2);
			}
		}

		function spawnShoot() {
			var fromLeft = Math.random() < 0.5;
			var speed = 4.5 + Math.random() * 4;
			var ang = (0.22 + Math.random() * 0.35);
			shoots.push({
				x: fromLeft ? Math.random() * W * 0.6 : W * 0.4 + Math.random() * W * 0.6,
				y: Math.random() * H * 0.55,
				vx: (fromLeft ? 1 : -1) * speed * Math.cos(ang),
				vy: speed * Math.sin(ang),
				len: 10 + Math.random() * 10,
				w: 0.9 + Math.random() * 0.9,
				life: 0, max: 45 + Math.random() * 35
			});
		}

		function drawShoot(t) {
			if (reduce) return;
			if (t > nextShoot && shoots.length < 3) {
				spawnShoot();
				nextShoot = t + 1500 + Math.random() * 3000;
			}
			for (var i = shoots.length - 1; i >= 0; i--) {
				var s = shoots[i];
				s.life++;
				s.x += s.vx; s.y += s.vy;
				var p = s.life / s.max;
				var alpha = p < 0.2 ? p / 0.2 : 1 - (p - 0.2) / 0.8;
				var tx = s.x - s.vx * s.len, ty = s.y - s.vy * s.len;
				var g = ctx.createLinearGradient(s.x, s.y, tx, ty);
				g.addColorStop(0, 'rgba(' + C.cursor + ',' + (0.85 * alpha).toFixed(3) + ')');
				g.addColorStop(1, 'rgba(' + C.cursor + ',0)');
				ctx.strokeStyle = g; ctx.lineWidth = s.w;
				ctx.beginPath(); ctx.moveTo(s.x, s.y); ctx.lineTo(tx, ty); ctx.stroke();
				if (s.life >= s.max || s.x < -60 || s.x > W + 60 || s.y > H + 60) shoots.splice(i, 1);
			}
		}

		// Named constellations. Normalized coords inside their box (x right, y down).
		var FIGS = {
			sagittarius: {
				label: 'SAGITTARIUS', labelAt: 2,
				stars: [[0.00,0.52,1.0],[0.22,0.40,1.0],[0.20,0.80,1.6],[0.36,0.14,1.1],[0.52,0.44,0.9],[0.62,0.80,1.2],[0.80,0.36,1.4],[0.90,0.64,0.9],[0.04,0.96,0.8]],
				links: [[0,1],[0,2],[1,2],[1,3],[3,4],[1,4],[4,5],[2,5],[4,6],[6,7],[7,5],[2,8]]
			},
			pisces: {
				label: 'PISCES', labelAt: 0,
				// 0 Alrescha (knot) · 1-5 western cord · 6-10 Circlet · 11-13 northern cord · 14-16 northern fish
				stars: [[1.00,0.90,1.3],[0.88,0.84,0.8],[0.76,0.80,0.8],[0.64,0.78,0.9],[0.53,0.74,0.8],[0.42,0.68,0.9],
					[0.30,0.58,1.0],[0.20,0.46,1.1],[0.07,0.52,1.2],[0.12,0.70,0.9],[0.25,0.74,0.9],
					[0.95,0.66,0.8],[0.90,0.46,0.9],[0.85,0.28,1.1],[0.78,0.08,0.9],[0.90,0.00,0.8],[0.96,0.14,0.9]],
				links: [[0,1],[1,2],[2,3],[3,4],[4,5],[5,6],[6,7],[7,8],[8,9],[9,10],[10,6],[0,11],[11,12],[12,13],[13,14],[14,15],[15,16],[16,13]]
			}
		};

		function stageRect() {
			var hr = host.getBoundingClientRect();
			var el = host.querySelector('.fg-hero-grid, .fg-hero__inner');
			if (!el) return { x: 0, y: 0, w: W, h: H };
			var r = el.getBoundingClientRect();
			return { x: r.left - hr.left, y: r.top - hr.top, w: r.width, h: r.height };
		}

		function drawFigure(fig, box, t, seed) {
			var drift = reduce ? 0 : Math.sin(t * 0.00012 + seed) * 4;
			var pulse = reduce ? 1 : 0.8 + 0.2 * Math.sin(t * 0.0011 + seed);
			var P = fig.stars.map(function (s) { return { x: box.x + s[0] * box.w + drift, y: box.y + s[1] * box.h, m: s[2] }; });

			ctx.lineWidth = 1.1;
			ctx.strokeStyle = 'rgba(' + C.line + ',' + (0.42 * pulse).toFixed(3) + ')';
			ctx.beginPath();
			for (var i = 0; i < fig.links.length; i++) {
				var a = P[fig.links[i][0]], b = P[fig.links[i][1]];
				ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y);
			}
			ctx.stroke();

			for (var k = 0; k < P.length; k++) {
				var p = P[k];
				var tw = reduce ? 1 : 0.75 + 0.25 * Math.sin(t * 0.002 + k * 1.7 + seed);
				var gr = 6 + p.m * 5;
				var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, gr);
				g.addColorStop(0, 'rgba(' + C.glow + ',' + (0.55 * tw).toFixed(3) + ')');
				g.addColorStop(1, 'rgba(' + C.glow + ',0)');
				ctx.fillStyle = g;
				ctx.beginPath(); ctx.arc(p.x, p.y, gr, 0, Math.PI * 2); ctx.fill();
				ctx.fillStyle = 'rgba(' + C.dot + ',' + (0.95 * tw).toFixed(3) + ')';
				ctx.beginPath(); ctx.arc(p.x, p.y, 1 + p.m, 0, Math.PI * 2); ctx.fill();
			}

		}

		function drawNamed(t) {
			var s = stageRect();
			var narrow = W < 700;
			// Sagittarius: empty space in the left column, below the paragraph
			var sw = narrow ? Math.min(s.w * 0.4, 170) : Math.min(s.w * 0.17, 240);
			var sbox = narrow
				? { x: s.x + s.w - sw - 8, y: s.y + 8, w: sw, h: sw * 0.78 }
				: { x: s.x + s.w * 0.03, y: s.y + s.h * 0.5, w: sw, h: sw * 0.78 };
			drawFigure(FIGS.sagittarius, sbox, t, 0);
			// Pisces: the long V lives in the strip under the portal card
			var pw = narrow ? s.w * 0.8 : Math.min(s.w * 0.5, 640);
			var ph = narrow ? 52 : 92;
			var pbox = { x: s.x + s.w - pw - (narrow ? s.w * 0.1 : s.w * 0.04), y: s.y + s.h - ph - (narrow ? 12 : 16), w: pw, h: ph };
			drawFigure(FIGS.pisces, pbox, t, 2.3);
		}

		function frame(t) {
			ctx.clearRect(0, 0, W, H);
			drawNebula(t);
			drawFar(t);

			var i, j, p, q, dx, dy, d, a;
			for (i = 0; i < pts.length; i++) {
				p = pts[i];
				if (!reduce) {
					// home position keeps its slow drift and wraps at the edges
					p.hx += p.bvx; p.hy += p.bvy;
					var wrapped = false;
					if (p.hx < -20) { p.hx = W + 20; wrapped = true; } else if (p.hx > W + 20) { p.hx = -20; wrapped = true; }
					if (p.hy < -20) { p.hy = H + 20; wrapped = true; } else if (p.hy > H + 20) { p.hy = -20; wrapped = true; }
					if (attract) {
						var tx = p.x < (attract.left + attract.right) / 2 ? attract.left : attract.right;
						var ax = tx - p.x, ay = attract.y - p.y, ad = Math.sqrt(ax * ax + ay * ay) || 1;
						var pull = Math.min(1, ad / 260) * 0.069;
						p.vx += ax / ad * pull; p.vy += ay / ad * pull;
						p.vx *= 0.94; p.vy *= 0.94;
						p.x += p.vx; p.y += p.vy;
					} else {
						// ease back to where it was
						if (wrapped) { p.x = p.hx; p.y = p.hy; }
						p.vx = (p.hx - p.x) * 0.045; p.vy = (p.hy - p.y) * 0.045;
						p.x += p.vx; p.y += p.vy;
					}
					dx = mouse.x - p.x; dy = mouse.y - p.y; d = dx * dx + dy * dy;
					if (d < 40000) { p.x += dx * 0.0025; p.y += dy * 0.0025; }
				}
			}

			ctx.lineWidth = 1;
			for (i = 0; i < pts.length; i++) {
				p = pts[i];
				for (j = i + 1; j < pts.length; j++) {
					q = pts[j];
					dx = p.x - q.x; dy = p.y - q.y;
					if (dx > LINK || dx < -LINK || dy > LINK || dy < -LINK) continue;
					d = Math.sqrt(dx * dx + dy * dy);
					if (d < LINK) {
						a = (1 - d / LINK) * C.lineA;
						ctx.strokeStyle = 'rgba(' + C.line + ',' + a.toFixed(3) + ')';
						ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(q.x, q.y); ctx.stroke();
					}
				}
				dx = p.x - mouse.x; dy = p.y - mouse.y; d = Math.sqrt(dx * dx + dy * dy);
				if (d < 180) {
					ctx.strokeStyle = 'rgba(' + C.cursor + ',' + ((1 - d / 180) * 0.5).toFixed(3) + ')';
					ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(mouse.x, mouse.y); ctx.stroke();
				}
			}

			for (i = 0; i < pts.length; i++) {
				p = pts[i];
				var tw = reduce ? 1 : 0.65 + 0.35 * Math.sin(t * 0.0015 + p.tw);
				if (p.bright) {
					var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, 7);
					g.addColorStop(0, 'rgba(' + C.glow + ',' + (0.45 * tw).toFixed(3) + ')');
					g.addColorStop(1, 'rgba(' + C.glow + ',0)');
					ctx.fillStyle = g;
					ctx.beginPath(); ctx.arc(p.x, p.y, 7, 0, Math.PI * 2); ctx.fill();
				}
				ctx.fillStyle = 'rgba(' + C.dot + ',' + (C.dotA * tw).toFixed(3) + ')';
				ctx.beginPath(); ctx.arc(p.x, p.y, p.bright ? p.r + 0.6 : p.r, 0, Math.PI * 2); ctx.fill();
			}

			drawNamed(t);
			drawShoot(t);
		}

		function loop(t) {
			raf = 0;
			if (!running || !visible || reduce) return;
			frame(t);
			raf = requestAnimationFrame(loop);
		}
		function kick() { if (!raf && running && visible && !reduce) raf = requestAnimationFrame(loop); }

		host.addEventListener('pointermove', function (e) {
			var r = host.getBoundingClientRect();
			mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top;
		}, { passive: true });
		host.addEventListener('pointerleave', function () { mouse.x = mouse.y = -9999; });

		if ('ResizeObserver' in window) new ResizeObserver(resize).observe(host);
		else window.addEventListener('resize', resize);
		if ('IntersectionObserver' in window) {
			new IntersectionObserver(function (es) { visible = es[0].isIntersecting; kick(); }).observe(host);
		}
		document.addEventListener('visibilitychange', function () { running = !document.hidden; kick(); });

		nextShoot = 800;
		resize();
		kick();
	}

	function scan() {
		var els = document.querySelectorAll('[data-fg-constellation]');
		for (var i = 0; i < els.length; i++) init(els[i]);
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
	else scan();
	if ('MutationObserver' in window) {
		new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
	}
})();
